import styled from 'styled-components'
export const PopUpTitleSection = styled.div`
	border: 1px solid #ddd;
	height: 100%;
	width: 120px;
	min-width: 120px;
`
export const PopUpInputSection = styled.div`
	border: 1px solid #ddd;
	height: 100%;
	width: 100%;
	flex: 1;
`
export const PopUpWrapper = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	height: 45px;
	border-bottom: 1px solid #ddd;
	padding-left: 10px;
`
export const SaveBtn = styled.div`
	margin-top: 10px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`
